export default "__VITE_ASSET__XSu3FG6f__"